export function translationRun(
  $rootScope,
  $translate
) {
  'ngInject';
  // Register change listener to refresh the translation after
  // a translate partial has been loaded.
  $rootScope.$on('$translatePartialLoaderStructureChanged', () => $translate.refresh()); // eslint-disable angular/on-watch
}
